@if (pageData) {

    <app-standard-page-layout class="w-full" 
        [title]="pageData.name"
        [subtitle]="pageData.seriesName + ' - ' + pageData.editionName"
        >

        <div class="mb-4">
            <p class="text-lg">{{ formatFromToDate(pageData.from, pageData.to) }}</p>
        </div>
        
        <div class="mb-8">
            <h3 class="mb-4">Viewing Location</h3>
                <div class="
                    grid
                    grid-cols-1
                    md:grid-cols-3
                    lg:grid-cols-4
                    gap-4
                    ">
                    @for (location of pageData.locationList; track location.id) {
                        <div class="block border rounded-lg p-5 border-slate-500">
                            <h3 class="mb-1">{{ location.name }}</h3>
                            <p class="text-base text-gray-600 mb-4">
                                {{ location.locationName }}
                            </p>
                        </div>
                    }
                </div>            
        </div>

        <div>
    <h3 class="mb-4">Performances</h3>

        <div class="flex justify-center mb-6">
            <div class="inline-flex rounded-lg border border-slate-700 overflow-hidden">
                <button
                    type="button"
                    class="
                        px-8
                        py-2
                        text-lg
                        transition
                    "
                    [class.bg-slate-700]="selectedView === 'actOrder'"
                    [class.text-white]="selectedView === 'actOrder'"
                    [class.bg-white]="selectedView !== 'actOrder'"
                    [class.text-slate-800]="selectedView !== 'actOrder'"
                    (click)="selectedView = 'actOrder'">

                    Act Order
                </button>

                <button
                    type="button"
                    class="
                        px-8
                        py-2
                        text-lg
                        transition
                    "
                    [class.bg-slate-700]="selectedView === 'ranking'"
                    [class.text-white]="selectedView === 'ranking'"
                    [class.bg-white]="selectedView !== 'ranking'"
                    [class.text-slate-800]="selectedView !== 'ranking'"
                    (click)="selectedView = 'ranking'">

                    Ranking
                </button>
            </div>
        </div>

        @if (selectedView === 'actOrder') {
            <app-programme-performance-list
                [programmePerformanceList]="pageData.performanceList"
                [performanceItemRatingList]="pageData.performanceItemRatingList">
            </app-programme-performance-list>
        }

        @if (selectedView === 'ranking') {
            <app-programme-performance-ranking
                [programmePerformanceList]="pageData.performanceList"
                [performanceItemRankingList]="pageData.performanceItemRankingList"
                [performanceItemRatingList]="pageData.performanceItemRatingList"
                (performanceItemRankedList)="onPerformanceItemRankedList($event)"
                (performanceItemRated)="onPerformanceItemRated($event)">
            </app-programme-performance-ranking>
        }
    </div>

    </app-standard-page-layout>

}
@else {

    <app-standard-page-layout
        class="w-full"
        title="Loading"
        subtitle="">
    </app-standard-page-layout>
}